export function CustomerList(XLSX, data) {
    console.log('customer list excel data: ', data)
    var wb = XLSX.utils.book_new();

    var ws = XLSX.utils.json_to_sheet(
        [
            { A: 'OCEAN TRANSPORT GROUP OF COMPANIES INC.' },
            { A: 'CUSTOMER LIST' },
        ]
        , { header: [], skipHeader: true });

    // XLSX.utils.sheet_add_json(ws, [
    //     {
    //         A: 'No',
    //         B: 'Company',
    //         C: 'Customer Name',
    //         D: 'Address',
    //         E: 'Contact Number',
    //         F: 'Email Address'
    //     }
    // ], { header: [], skipHeader: true, origin: -1 });
    XLSX.utils.sheet_add_json(ws, [
        {
            A: 'Code',
            B: 'Title',
            C: 'Company',
            D: 'First Name',
            E: 'Middle Initial',
            F: 'Last Name',
            G: 'Address',
            H: 'Contact Number',
            I: 'Email Address',
            J: 'Is Active',
            K: 'Is Rates SQ Goods Commodity',
            L: 'With Account',
            M: 'Payment Terms in Days',
            N: 'Company Group',
            O: 'Customer Id',
            P: 'Customer Name',
            Q: 'Is Guest',
        }
    ], { header: [], skipHeader: true, origin: -1 });

    if (data && data.length > 0) {
        var sortedData = data.sort(function (a, b) {
            var x = a.code.toLowerCase(); // ignore upper and lowercase
            var y = b.code.toLowerCase(); // ignore upper and lowercase
            if (x < y) {
                return -1;
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        sortedData.forEach((ele, id) => {
            var mi = ele.middleInitial ? ele.middleInitial : '';
            var fn = ele.firstName ? ele.firstName : '';
            var ln = ele.lastName ? ele.lastName : '';
            // var customerName = fn + mi + ln;
            // XLSX.utils.sheet_add_json(ws, [
            //     {
            //         A: id + 1,
            //         B: ele.company,
            //         C: customerName,
            //         D: ele.address,
            //         E: ele.contactNum,
            //         F: ele.customerContactEmail,
            //     }
            // ], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(ws, [
            {
                A: ele.code,
                B: ele.title,
                C: ele.company,
                D: fn,
                E: mi,
                F: ln,
                G: ele.address,
                H: ele.contactNum,
                I: ele.customerContactEmail,
                J: ele.isActive ? 'Yes' : 'No',
                K: ele.isRatesSQGoodsCommodity ? 'Yes' : 'No',
                L: ele.withAccount ? 'Yes' : 'No',
                M: ele.paymentTermsInDays,
                N: ele.companyGroup,
                O: ele.customerId,
                P: ele.customerName,
                Q: ele.isGuest ? 'Yes' : 'No',
            }
            ], { header: [], skipHeader: true, origin: -1 });
        });
    }

    var wscols = [
        { wch: 15 }, // Code
        { wch: 5 }, // Title
        { wch: 30 }, // Company
        { wch: 15 }, // First Name
        { wch: 15 }, // Middle Initial
        { wch: 15 }, // Last Name
        { wch: 35 }, // Address
        { wch: 15 }, // Contact Number
        { wch: 25 }, // Email Address
        { wch: 10 }, // Is Active
        { wch: 25 }, // Is Rates SQ Goods Commodity
        { wch: 15 }, // With Account
        { wch: 25 }, // Payment Terms in Days
        { wch: 20 }, // Company Group
        { wch: 15 }, // Customer Id
        { wch: 35 }, // Customer Name
        { wch: 10 }, // Is Guest
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Customer List");

    XLSX.writeFile(wb, "Customer_List.xlsx");
}